(function waitForShippingBar() {
  const container = document.querySelector(".shipping-bar-message");
  const bar = document.querySelector(".dynamic-shipping-bar");
  if (!container || !bar) {
    requestAnimationFrame(waitForShippingBar);
    return;
  }

  const defaultColour = bar.dataset.defaultColour;
  const progressColour = bar.dataset.progressColour;
  const threshold = parseFloat(container.dataset.threshold);
  const initialCartValue = parseFloat(container.dataset.initialCartValue || "0");

  const defaultNotice = container.querySelector(".shipping-bar-default");
  const progressNotice = container.querySelector(".shipping-bar-progress");
  const qualifiedNotice = container.querySelector(".shipping-bar-qualified");
  const dynamicAmount = container.querySelector(".dynamic-amount");

  const loading = container.querySelector(".shipping-bar-loading");
  const content = container.querySelector(".shipping-bar-states");

  function formatCurrency(value) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    }).format(value);
  }

  function updateShippingNotice(cartTotal) {
    const cartValue = cartTotal / 100;

    if (cartValue === 0) {
      bar.style.backgroundColor = defaultColour;
      defaultNotice?.classList.remove("d-none");
      progressNotice?.classList.add("d-none");
      qualifiedNotice?.classList.add("d-none");
    } else if (cartValue < threshold) {
      bar.style.backgroundColor = progressColour;
      const remaining = threshold - cartValue;
      dynamicAmount.textContent = formatCurrency(remaining);
      defaultNotice?.classList.add("d-none");
      progressNotice?.classList.remove("d-none");
      qualifiedNotice?.classList.add("d-none");
    } else {
      bar.style.backgroundColor = defaultColour;
      defaultNotice?.classList.add("d-none");
      progressNotice?.classList.add("d-none");
      qualifiedNotice?.classList.remove("d-none");
    }
  }

  function fetchCartAndUpdate() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const currentTotal = cart.total_price;

        // Only show loading if the total has changed
        if (currentTotal !== initialCartValue) {
          if (loading && content) {
            loading.style.display = "flex";
            content.style.display = "none";
          }

          updateShippingNotice(currentTotal);
        }
      })
      .catch((err) => console.error("Failed to load cart:", err))
      .finally(() => {
        if (loading && content) {
          loading.style.display = "none";
          content.style.display = "flex";
        }
      });
  }

  // Detect changes inside cart drawer
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      // Delay slightly to allow DOM/cart state to settle
      setTimeout(() => {
        document.dispatchEvent(new Event("cart:refresh"));
      }, 300);
    });
  
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }


  // Initial update from Liquid-rendered value
  updateShippingNotice(initialCartValue);

  // Fire background update to correct if needed
  fetchCartAndUpdate();

  // Re-fetch if cart is updated
  document.addEventListener("cart:refresh", fetchCartAndUpdate);
  document.addEventListener("cart:updated", () => {
    document.dispatchEvent(new Event("cart:refresh"));
  });

  // Observe cart count bubble for changes
  const cartCount = document.querySelector('.cart-count-bubble > span[aria-hidden="true"]');
  if (cartCount && cartCount.firstChild) {
    new MutationObserver(() => {
      document.dispatchEvent(new Event("cart:refresh"));
    }).observe(cartCount.firstChild, {
      characterData: true,
      subtree: false,
    });
  }

  // Handle removal from cart
  document.addEventListener("click", (e) => {
    const removeButton = e.target.closest("cart-remove-button");
    if (removeButton) {
      setTimeout(() => {
        document.dispatchEvent(new Event("cart:refresh"));
      }, 500);
    }
  });

  console.log("🚀 Hybrid shipping bar script fired at:", performance.now().toFixed(2), "ms");
})();
